
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aboutOS7HpsGFDFSTbbd4iXDP92Iuvckam0GQw5dgZEXCgBIMeta } from "/vercel/path0/pages/about.vue?macro=true";
import { default as gamesh_ht2EgyaionQh0y__u_45QuSZppovxWiSWN_459jdSflV4Meta } from "/vercel/path0/pages/games.vue?macro=true";
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as teamsaCMVoK6R7F2cs1h_450YN6E_7fTl54tTrSxFqb28oX3oQMeta } from "/vercel/path0/pages/teams.vue?macro=true";
import { default as contact6cZoOGxJBTY9l_45DSf37OWQKprIBU1PffJx7PVn14dCsMeta } from "/vercel/path0/pages/contact.vue?macro=true";
import { default as legal_45ppz47YoHGFjAWD650XNXtjwv1oWRdjc3oBMQox1LNJMU8Meta } from "/vercel/path0/pages/legal-pp.vue?macro=true";
import { default as legal_45tocnJ4idk_omQU4yNmifnL8lP3yh5C62ABaOlUZve3vKZYMeta } from "/vercel/path0/pages/legal-toc.vue?macro=true";
import { default as indexfXlVfbm7D2SlS1UhON_rBCR2fHcBZ5SRA22N0Gx_QVMMeta } from "/vercel/path0/pages/[team]/index.vue?macro=true";
import { default as table5j9CwUOwsJvkvfnDeOC901MaELAGNsYQGblNVil1Nc8Meta } from "/vercel/path0/pages/[team]/table.vue?macro=true";
import { default as _91game_93JSPTSHXbAgPsqKPdmKF9Dhu39CuvqFoaOx9uPpssvHoMeta } from "/vercel/path0/pages/[team]/[game].vue?macro=true";
import { default as indexo1_45I9jO9TMaUjCj2uBP72zcyCjw_45kf_45KRHgR5EtQwN0Meta } from "/vercel/path0/pages/leagues/index.vue?macro=true";
import { default as results8yUGg9V4mUa2f1uiGAyKl_C6EPK7_459xcdXJeDnO8hD4Meta } from "/vercel/path0/pages/[team]/results.vue?macro=true";
import { default as fixturesVIR3gErkEl7PiSpfVPudQcXllSzBTKCJAJ3fu0ZhxYQMeta } from "/vercel/path0/pages/[team]/fixtures.vue?macro=true";
import { default as statisticsAJaBfaJKalCKCWl5oC9_8Wts4KKnyHt9nBRfdCN_yXkMeta } from "/vercel/path0/pages/[team]/statistics.vue?macro=true";
import { default as table_45awayliB9_f32NSuHWFgh_45VGvy9r2uSrKrAl6C521ZJO6XGAMeta } from "/vercel/path0/pages/[team]/table-away.vue?macro=true";
import { default as table_45home_45HM8LotjoCPhn6p_2BKs7EC1hspp7CxPvOCC9rVX1nIMeta } from "/vercel/path0/pages/[team]/table-home.vue?macro=true";
import { default as results_45away9QU7SD0FcnKJQKXfF_0OyIqfodfiatd_Tl726wbVlAAMeta } from "/vercel/path0/pages/[team]/results-away.vue?macro=true";
import { default as results_45homeRhkYyzwv94M8rEHHiuixoCWTYDcDJLXObBDKjHpMWjwMeta } from "/vercel/path0/pages/[team]/results-home.vue?macro=true";
import { default as fixtures_45awayQpnH79VETiwSxtQhdOB1GRgrng5x4NvRlZMVbhYSFsUMeta } from "/vercel/path0/pages/[team]/fixtures-away.vue?macro=true";
import { default as fixtures_45homeA2AGTnfwIN9NmgScF5V8qy3EV5d4pW8MhIaYxD2D8gAMeta } from "/vercel/path0/pages/[team]/fixtures-home.vue?macro=true";
import { default as indexGwAoGBihZj7rMNCvuhcMOWw6Clct0pbyRoCedZ2Mt2UMeta } from "/vercel/path0/pages/leagues/[league]/index.vue?macro=true";
import { default as tableuMCxHay1WjQ9lmvNcMZLPU08QaLfagv4S1mF92JnVpUMeta } from "/vercel/path0/pages/leagues/[league]/table.vue?macro=true";
import { default as teamsIhfuU4MCjC3RJYwOdrJMeeO_45uDqb9HwbuxJPXRTvYM8Meta } from "/vercel/path0/pages/leagues/[league]/teams.vue?macro=true";
import { default as _91game_93tZrrcqOr_45PzRbS8Vi3Cct1TTiUJr5pV_7TT7wUfJz4wMeta } from "/vercel/path0/pages/leagues/[league]/[game].vue?macro=true";
import { default as resultsJ4gsxlmOfByIYOsSpmyckwlsqWhYyiIgRMYT9YNnIXUMeta } from "/vercel/path0/pages/leagues/[league]/results.vue?macro=true";
import { default as fixturesICWfhgXAbq85slwEX_45SkrXMmIswQ0yT23adUA8_3AyAMeta } from "/vercel/path0/pages/leagues/[league]/fixtures.vue?macro=true";
import { default as statisticsquJ1s_45NDBB8SWAUbSS8lpRBp5iv5ZhlkwH8plwDzVFEMeta } from "/vercel/path0/pages/leagues/[league]/statistics.vue?macro=true";
export default [
  {
    name: "about",
    path: "/chi-siamo",
    component: () => import("/vercel/path0/pages/about.vue")
  },
  {
    name: "games",
    path: "/partite",
    component: () => import("/vercel/path0/pages/games.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "teams",
    path: "/squadre",
    component: () => import("/vercel/path0/pages/teams.vue")
  },
  {
    name: "contact",
    path: "/contatto",
    component: () => import("/vercel/path0/pages/contact.vue")
  },
  {
    name: "legal-pp",
    path: "/legal-pp",
    component: () => import("/vercel/path0/pages/legal-pp.vue")
  },
  {
    name: "legal-toc",
    path: "/legal-toc",
    component: () => import("/vercel/path0/pages/legal-toc.vue")
  },
  {
    name: "team",
    path: "/:team",
    meta: indexfXlVfbm7D2SlS1UhON_rBCR2fHcBZ5SRA22N0Gx_QVMMeta || {},
    component: () => import("/vercel/path0/pages/[team]/index.vue")
  },
  {
    name: "team-table",
    path: "/:team()/classifica",
    meta: table5j9CwUOwsJvkvfnDeOC901MaELAGNsYQGblNVil1Nc8Meta || {},
    component: () => import("/vercel/path0/pages/[team]/table.vue")
  },
  {
    name: "team-game",
    path: "/:team()/partite/:game()",
    meta: { ...(_91game_93JSPTSHXbAgPsqKPdmKF9Dhu39CuvqFoaOx9uPpssvHoMeta || {}), ...{"middleware":["game-data"]} },
    component: () => import("/vercel/path0/pages/[team]/[game].vue")
  },
  {
    name: "leagues",
    path: "/leghe",
    component: () => import("/vercel/path0/pages/leagues/index.vue")
  },
  {
    name: "team-results",
    path: "/:team()/risultato",
    meta: results8yUGg9V4mUa2f1uiGAyKl_C6EPK7_459xcdXJeDnO8hD4Meta || {},
    component: () => import("/vercel/path0/pages/[team]/results.vue")
  },
  {
    name: "team-fixtures",
    path: "/:team()/partite",
    meta: fixturesVIR3gErkEl7PiSpfVPudQcXllSzBTKCJAJ3fu0ZhxYQMeta || {},
    component: () => import("/vercel/path0/pages/[team]/fixtures.vue")
  },
  {
    name: "team-statistics",
    path: "/:team()/statistics",
    meta: statisticsAJaBfaJKalCKCWl5oC9_8Wts4KKnyHt9nBRfdCN_yXkMeta || {},
    component: () => import("/vercel/path0/pages/[team]/statistics.vue")
  },
  {
    name: "team-table-away",
    path: "/:team()/classifica/trasferta",
    meta: table_45awayliB9_f32NSuHWFgh_45VGvy9r2uSrKrAl6C521ZJO6XGAMeta || {},
    component: () => import("/vercel/path0/pages/[team]/table-away.vue")
  },
  {
    name: "team-table-home",
    path: "/:team()/classifica/casa",
    meta: table_45home_45HM8LotjoCPhn6p_2BKs7EC1hspp7CxPvOCC9rVX1nIMeta || {},
    component: () => import("/vercel/path0/pages/[team]/table-home.vue")
  },
  {
    name: "team-results-away",
    path: "/:team()/risultato/trasferta",
    meta: results_45away9QU7SD0FcnKJQKXfF_0OyIqfodfiatd_Tl726wbVlAAMeta || {},
    component: () => import("/vercel/path0/pages/[team]/results-away.vue")
  },
  {
    name: "team-results-home",
    path: "/:team()/risultato/casa",
    meta: results_45homeRhkYyzwv94M8rEHHiuixoCWTYDcDJLXObBDKjHpMWjwMeta || {},
    component: () => import("/vercel/path0/pages/[team]/results-home.vue")
  },
  {
    name: "team-fixtures-away",
    path: "/:team()/partite/trasferta",
    meta: fixtures_45awayQpnH79VETiwSxtQhdOB1GRgrng5x4NvRlZMVbhYSFsUMeta || {},
    component: () => import("/vercel/path0/pages/[team]/fixtures-away.vue")
  },
  {
    name: "team-fixtures-home",
    path: "/:team()/partite/casa",
    meta: fixtures_45homeA2AGTnfwIN9NmgScF5V8qy3EV5d4pW8MhIaYxD2D8gAMeta || {},
    component: () => import("/vercel/path0/pages/[team]/fixtures-home.vue")
  },
  {
    name: "leagues-league",
    path: "/leghe/:league()",
    meta: indexGwAoGBihZj7rMNCvuhcMOWw6Clct0pbyRoCedZ2Mt2UMeta || {},
    component: () => import("/vercel/path0/pages/leagues/[league]/index.vue")
  },
  {
    name: "leagues-league-table",
    path: "/leghe/:league()/classifica",
    meta: tableuMCxHay1WjQ9lmvNcMZLPU08QaLfagv4S1mF92JnVpUMeta || {},
    component: () => import("/vercel/path0/pages/leagues/[league]/table.vue")
  },
  {
    name: "leagues-league-teams",
    path: "/leagues/:league()/teams",
    meta: teamsIhfuU4MCjC3RJYwOdrJMeeO_45uDqb9HwbuxJPXRTvYM8Meta || {},
    component: () => import("/vercel/path0/pages/leagues/[league]/teams.vue")
  },
  {
    name: "leagues-league-game",
    path: "/leghe/:league()/partite/:game()",
    meta: { ...(_91game_93tZrrcqOr_45PzRbS8Vi3Cct1TTiUJr5pV_7TT7wUfJz4wMeta || {}), ...{"middleware":["game-data"]} },
    component: () => import("/vercel/path0/pages/leagues/[league]/[game].vue")
  },
  {
    name: "leagues-league-results",
    path: "/leghe/:league()/risultato",
    meta: resultsJ4gsxlmOfByIYOsSpmyckwlsqWhYyiIgRMYT9YNnIXUMeta || {},
    component: () => import("/vercel/path0/pages/leagues/[league]/results.vue")
  },
  {
    name: "leagues-league-fixtures",
    path: "/leghe/:league()/partite",
    meta: fixturesICWfhgXAbq85slwEX_45SkrXMmIswQ0yT23adUA8_3AyAMeta || {},
    component: () => import("/vercel/path0/pages/leagues/[league]/fixtures.vue")
  },
  {
    name: "leagues-league-statistics",
    path: "/leghe/:league()/statistiche",
    meta: statisticsquJ1s_45NDBB8SWAUbSS8lpRBp5iv5ZhlkwH8plwDzVFEMeta || {},
    component: () => import("/vercel/path0/pages/leagues/[league]/statistics.vue")
  }
]